import { gql } from 'apollo-boost';

export const getPageOrdersQuery = gql`
  query Orders($skip: Int!, $take: Int!, $status: OrderStatus) {
    Orders(input: { status: $status, skip: $skip, take: $take }) {
      totalCount
      items {
        id
        contact
        createDate
        finalPrice
        status
        description
        items {
          product {
            id
            code
            title
          }
          price
          count
          status
        }
      }
    }
  }
`;

export const setOrderStatusQuery = gql`
  mutation SetOrderStatus($id: ID!, $status: OrderStatus!) {
    SetOrderStatus(input: { id: $id, status: $status }) {
      id
      status
    }
  }
`;

export const setOrderItemsStatusQuery = gql`
  mutation SetOrderItemsStatus(
    $orderId: ID!
    $status: OrderItemStatus!
    $orderItemsIds: [ID!]!
  ) {
    SetOrderItemsStatus(
      input: {
        orderId: $orderId
        status: $status
        orderItemsIds: $orderItemsIds
      }
    ) {
      orderId
      status
      orderItemsIds
    }
  }
`;

export const newOrderQuery = gql`
  mutation NewOrder(
    $contact: String!
    $description: String!
    $pageName: String!
    $items: [NewOrderItemInput!]!
  ) {
    NewOrder(
      input: {
        contact: $contact
        description: $description
        pageName: $pageName
        items: $items
      }
    ) {
      refId
    }
  }
`;
